module.exports = __webpack_public_path__ + "static/media/portal-image-empty.80476182.svg";